import React, { useCallback } from 'react'
import { MainLayout } from '../../../../../../shared/components/main-layout/main-layout.component'
import { ConsumerAddressView } from './components/consumer-address-view/consumer-address-view.component'
import { ConsumerAddressStepProps } from './consumer-address-step.props'

export const ConsumerAddressStep = (props: ConsumerAddressStepProps) => {
  const onComplete = () => props.onComplete(props.step)

  const goBack = useCallback(() => {
    props.goBack(props.step)
  }, [props.step, props.goBack])

  return (
    <MainLayout step={props.step} hideFooter>
      <ConsumerAddressView
        onComplete={onComplete}
        goBack={goBack}
        step={props.step}
      />
    </MainLayout>
  )
}
